var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentimentNeutral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 28H30.5V31H18.5V28Z",
    fill: "#F4D06F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 22C33.1569 22 34.5 20.6569 34.5 19C34.5 17.3431 33.1569 16 31.5 16C29.8431 16 28.5 17.3431 28.5 19C28.5 20.6569 29.8431 22 31.5 22Z",
    fill: "#F4D06F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 22C19.1569 22 20.5 20.6569 20.5 19C20.5 17.3431 19.1569 16 17.5 16C15.8431 16 14.5 17.3431 14.5 19C14.5 20.6569 15.8431 22 17.5 22Z",
    fill: "#F4D06F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.48 4C13.44 4 4.5 12.96 4.5 24C4.5 35.04 13.44 44 24.48 44C35.54 44 44.5 35.04 44.5 24C44.5 12.96 35.54 4 24.48 4ZM24.5 40C15.66 40 8.5 32.84 8.5 24C8.5 15.16 15.66 8 24.5 8C33.34 8 40.5 15.16 40.5 24C40.5 32.84 33.34 40 24.5 40Z",
    fill: "#F4D06F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentNeutral);
export default __webpack_public_path__ + "static/media/sentiment_neutral.08065367686e5d1cb5c049bdfc6ff8d5.svg";
export { ForwardRef as ReactComponent };